import type { ColoredDotProps } from '../dot.component';
import { Dot } from '../dot.component';

export const SuccessDot = (props: ColoredDotProps) => <Dot color='success' {...props} />;
